import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
// import api from '../utils/api';
import html2canvas from 'html2canvas';
import axios from 'axios';

const CouponForm = () => {
  //   const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  //   const [code, setCode] = useState('');
  //   const [expirationDate, setExpirationDate] = useState(new Date());
  //   const [maxRedemptions, setMaxRedemptions] = useState('');
  //   const [verificationMethod, setVerificationMethod] = useState('manual');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { restaurantId, couponId } = useParams();

  useEffect(() => {
    if (couponId) {
      fetchTemplates();
    }
  }, [couponId]);

  //   const fetchCoupon = async () => {
  //     try {
  //       const response = await api.get(
  //         `/restaurants/${restaurantId}/coupons/${couponId}`
  //       );
  //       const coupon = response.data;
  //       setTitle(coupon.title);
  //       setDescription(coupon.description);
  //       setCode(coupon.code);
  //       setExpirationDate(new Date(coupon.expirationDate));
  //       setMaxRedemptions(coupon.maxRedemptions || '');
  //       setVerificationMethod(coupon.verificationMethod);
  //     } catch (error) {
  //       console.error('Error fetching coupon:', error);
  //       setError('Failed to fetch coupon details.');
  //     }
  //   };
  const fetchTemplates = async () => {
    try {
      const token = localStorage.getItem('ownerToken');

      const response = await axios.get(
        `/api/restaurants/${restaurantId}/coupontemplates/${couponId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      //   console.log(response.data);
      const coupon = response.data;
      console.log(coupon);
      //   setTitle(coupon.title);
      setDescription(coupon.description);
      //   setCode(coupon.code);
      //   setExpirationDate(new Date(coupon.expirationDate));
      //       setMaxRedemptions(coupon.maxRedemptions || '');
      //   setTemplates(response.data);
      setLoading(false);
    } catch (error) {
      //   toast.error('Failed to load coupon templates');
      setError('Failed to fetch coupon details.');

      //   setLoading(false);
    }
  };

  const generateCouponImage = async () => {
    const couponElement = document.getElementById('coupon-preview');
    if (couponElement) {
      const canvas = await html2canvas(couponElement);
      return canvas.toDataURL('image/png');
    }
    return null;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    const token = localStorage.getItem('ownerToken');

    try {
      const imageDataUrl = await generateCouponImage();
      const data = {
        // title,
        description,
        // code,
        // expirationDate,
        // maxRedemptions: maxRedemptions || null,
        // verificationMethod,
        imageUrl: imageDataUrl,
        restaurantId,
      };

      if (couponId) {
        await axios.put(
          `/restaurants/${restaurantId}/coupons/${couponId}`,
          data
        );
      } else {
        await axios.post(
          `/api/restaurants/${restaurantId}/coupontemplates/create`,
          data,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
      }
      navigate(`/restaurant/${restaurantId}/coupons`);
    } catch (error) {
      console.error('Error saving coupon:', error);
      setError(
        'Failed to save coupon. ' +
          (error.response?.data?.message || 'Please try again.')
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className='max-w-md mx-auto mt-10'>
      <h2 className='text-2xl font-bold mb-4'>
        {couponId ? 'Edit Coupon' : 'Create New Coupon'}
      </h2>
      <form onSubmit={handleSubmit} className='space-y-4'>
        {/* <div> */}
        {/* <label
            htmlFor='title'
            className='block text-sm font-medium text-gray-700'
          >
            Coupon Title
          </label> */}
        {/* <input
            type='text'
            id='title'
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            required
            className='mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50'
          /> */}
        {/* </div> */}
        <div>
          <label
            htmlFor='description'
            className='block text-sm font-medium text-gray-700'
          >
            Description
          </label>
          <textarea
            id='description'
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            required
            rows='3'
            className='mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50'
          ></textarea>
        </div>
        {/* <div>
          <label
            htmlFor='code'
            className='block text-sm font-medium text-gray-700'
          >
            Coupon Code
          </label>
          <input
            type='text'
            id='code'
            value={code}
            onChange={(e) => setCode(e.target.value)}
            required
            className='mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50'
          />
        </div> */}
        {/* <div>
          <label
            htmlFor='expirationDate'
            className='block text-sm font-medium text-gray-700'
          >
            Expiration Date
          </label>
          <DatePicker
            selected={expirationDate}
            onChange={(date) => setExpirationDate(date)}
            minDate={new Date()}
            className='mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50'
          />
        </div> */}
        {/* <div>
          <label
            htmlFor='maxRedemptions'
            className='block text-sm font-medium text-gray-700'
          >
            Max Redemptions (optional)
          </label>
          <input
            type='number'
            id='maxRedemptions'
            value={maxRedemptions}
            onChange={(e) => setMaxRedemptions(e.target.value)}
            min='1'
            className='mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50'
          />
        </div> */}
        {/* <div>
          <label className='block text-sm font-medium text-gray-700'>
            Verification Method
          </label>
          <div className='mt-2'>
            <label className='inline-flex items-center'>
              <input
                type='radio'
                className='form-radio'
                name='verificationMethod'
                value='manual'
                checked={verificationMethod === 'manual'}
                onChange={(e) => setVerificationMethod(e.target.value)}
              />
              <span className='ml-2'>Manual Code Entry</span>
            </label>
            <label className='inline-flex items-center ml-6'>
              <input
                type='radio'
                className='form-radio'
                name='verificationMethod'
                value='qr'
                checked={verificationMethod === 'qr'}
                onChange={(e) => setVerificationMethod(e.target.value)}
              />
              <span className='ml-2'>QR Code</span>
            </label>
          </div>
        </div> */}
        <div
          id='coupon-preview'
          className='bg-white p-4 border rounded-lg shadow-md'
        >
          {/* <h3 className='text-lg font-bold mb-2'>{title}</h3> */}
          <p className='mb-2'>{description}</p>
          {/* <p className='mb-2'>Code: {code}</p> */}
          {/* <p>Expires: {expirationDate.toLocaleDateString()}</p> */}
        </div>
        {error && <p className='text-red-500'>{error}</p>}
        <button
          type='submit'
          disabled={loading}
          className='w-full py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500'
        >
          {loading ? 'Saving...' : couponId ? 'Update Coupon' : 'Create Coupon'}
        </button>
      </form>
    </div>
  );
};

export default CouponForm;
